import { css } from "styled-components";

export const NOTO = css`
  ${`'Noto Sans KR', sans-serif`}
`;

export const ROBOTO = css`
  ${`'Roboto', sans-serif`}
`;

export const PRETENDARD = css`
  ${`'Pretendard'`}
`;
